import type { CSSProperties } from 'react';

/** Единая сетка строки workspace: направление | номер | дата | контекст | задачи | статус */
export const WORKSPACE_GRID_ROW: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '2fr 1fr 1fr 2fr 1fr 1fr',
  alignItems: 'center',
  gap: 6,
  minHeight: 40,
  padding: '5px 10px',
};

export const WORKSPACE_GRID_CELL: CSSProperties = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

/** Маршруты с задачами (legacy 7 колонок). */
export const WORKSPACE_ROUTE_GRID_ROW: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '2fr 1fr 1fr 1.5fr 2fr 1fr 1fr',
  alignItems: 'center',
  gap: 6,
  minHeight: 40,
  padding: '5px 10px',
};

/** Реестр маршрутов Workspace: маршрут | заявки | клиенты | перевозчик | договор | погрузка | выгрузка | задачи | статус. */
export const WORKSPACE_ROUTE_REGISTRY_GRID_ROW: CSSProperties = {
  display: 'grid',
  gridTemplateColumns:
    'minmax(68px, 0.65fr) minmax(96px, 1.05fr) minmax(108px, 1.2fr) minmax(88px, 0.9fr) minmax(112px, 1.2fr) minmax(58px, 0.62fr) minmax(58px, 0.62fr) minmax(110px, 1fr) minmax(92px, 0.9fr)',
  alignItems: 'center',
  gap: 6,
  minHeight: 48,
  padding: '6px 10px',
};

export const WORKSPACE_ROUTE_REGISTRY_HEADER_ROW: CSSProperties = {
  ...WORKSPACE_ROUTE_REGISTRY_GRID_ROW,
  position: 'sticky',
  top: 0,
  zIndex: 4,
  minHeight: 40,
  background: 'var(--ant-color-bg-container, #ffffff)',
  borderBottom: '1px solid var(--ant-color-border-secondary, #f0f0f0)',
  fontSize: 12,
  fontWeight: 600,
  color: 'var(--ant-color-text-secondary, rgba(0,0,0,0.65))',
  boxShadow: '0 1px 0 rgba(0,0,0,0.06)',
};

/**
 * Заявки в workspace — очередь задач (6 колонок):
 * № заявки | Направление | Клиент | Заявка клиента | Задачи | Статус
 */
export const WORKSPACE_APPLICATION_GRID_ROW: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'minmax(128px, 1.45fr) minmax(100px, 2fr) minmax(88px, 1.25fr) minmax(128px, 1.45fr) 76px minmax(92px, 1fr)',
  alignItems: 'center',
  gap: 6,
  minHeight: 50,
  padding: '6px 10px',
};

/**
 * Реестр заявок Workspace → «Все заявки» (7 колонок):
 * № заявки | Направление | Клиент | Заявка клиента | Задачи | Статус оплаты | Статус заявки
 */
export const WORKSPACE_APPLICATION_REGISTRY_GRID_ROW: CSSProperties = {
  display: 'grid',
  gridTemplateColumns:
    'minmax(128px, 1.45fr) minmax(100px, 2fr) minmax(88px, 1.25fr) minmax(128px, 1.45fr) 76px minmax(108px, 1.05fr) minmax(92px, 1fr)',
  alignItems: 'center',
  gap: 6,
  minHeight: 54,
  padding: '7px 10px',
};
